import { Badge, Text } from '@/design-system/components/ui';

interface Props {
  label: string;
  value: string;
}

export const TriggerTextDetail = ({ label, value }: Props) => {
  return (
    <div className="tw:flex tw:flex-col">
      <Text variant="body-sm" weight="bold" className="tw:mb-1">
        {label}
      </Text>
      <Badge size="sm" className="tw:max-w-[300px] tw:whitespace-normal tw:break-words">
        {value}
      </Badge>
    </div>
  );
};
